module.exports = __webpack_public_path__ + "static/media/icn-edit.679fea4b.svg";